<link rel='stylesheet' href='https://cdn-uicons.flaticon.com/2.6.0/uicons-brands/css/uicons-brands.css'>
<link rel='stylesheet' href='https://cdn-uicons.flaticon.com/2.6.0/uicons-regular-rounded/css/uicons-regular-rounded.css'>
            <style>
                     .socialmediaicon li {
    margin-right: 10px;
  }
  
  @media (max-width: 767px) {
    .header-fix {
        position: relative;
    }
}
@media (max-width: 390px) {
    .header-social-w {
        width: 70%;
    }
}
@media (max-width: 469px) {
    .header-social-w {
        width: 70%;
    }
}
@media (max-width: 767px) {
    .header-social-w {
        width: 80%;
    }
}
@media (max-width: 991px) {
    .header-social-w {
        width: 85%;
    }
}
@media (max-width: 1199px) {
    .header-social-w {
        width: 88%;
    }
}
@media (max-width: 767px) {
    .socialmediaicon .m-hide, .sp-desktop-show {
        display: none;
    }
}
              
element.style {
}
[type=button]:not(:disabled), [type=reset]:not(:disabled), [type=submit]:not(:disabled), button:not(:disabled) {
    cursor: pointer;
}
@media (max-width: 390px) {
    .b2clogin, .b2csignup {
        font-size: 12px;
        padding: 3px 12px;
    }
}
@media (max-width: 414px) {
    .b2clogin, .b2csignup {
        font-size: 12px;
        padding: 3px 10px;
    }
}
@media (max-width: 469px) {
    .b2clogin {
        font-size: 11px;
        padding: 3px 10px;
    }
}
@media (min-width: 470px) {
    .b2clogin, .b2csignup {
        font-size: 14px;
        padding: 5px 15px;
    }
}
</style>
              
<nav class="navbar navbar-dark bg-black sticky-top header-fix" style="
    background-color: #072c50 !important;
    background-image: linear-gradient(#072c50, #072c50) !important;
        height: auto !important;
                
}">
      <div class="header-fix" style="
    width: 100%;
    z-index: 999;">
    <div class="header-top flex-center-space" style="    background-color: #f8bd23; 
    flex-wrap: wrap;
    
    align-items: center;
    display: flex;
        justify-content: space-between;

    height: 25px !important;
    padding: 3px 5px;
    position: relative !important;
    width: 100% !important;">
        <div class="header-social-w" style="    width: 92%;
">
            <div class="left flex-center float-left" style="
    align-items: center;
    display: flex
;">
    
                <ul class="socialmediaicon" style=" list-style-type: none; display: inline-flex
;">
                    <li><a href="#" target="_blank" alt="Instagram" rel="noreferrer" data-toggle="tooltip"
                            data-placement="bottom" title="Instagram"
                            style="align-items: center; display: flex; height: auto; font-size: 11px;"><i
                                class="fi fi-brands-instagram"
                                style="color:black; margin-right:4px; margin-top: 3px;"></i><span
                                class="m-hide">Instagram</span></a></li>
                    <li><a href="#" target="_blank" alt="Facebook" rel="noreferrer" data-toggle="tooltip"
                            data-placement="bottom" title="Facebook" style="  
    align-items: center; display: flex; height: auto; font-size: 11px;"><i class="fi fi-brands-facebook"
                                style="color:black; margin-top: 3px; margin-right:4px;"></i><span
                                class="m-hide">Facebook</span></a></li>
                    <li><a href="#" target="_blank" alt="Twitter" rel="noreferrer" data-toggle="tooltip"
                            data-placement="bottom" title="Twitter"
                            style="align-items: center; display: flex; height: auto; font-size: 11px;"><i
                                class="fi fi-brands-twitter"
                                style="color:black; margin-top: 3px; margin-right:4px;"></i><span
                                class="m-hide">Twitter</span></a></li>
                    <li><a href="https://T.me/care1xwazir" target="_blank" alt="Telegram Channel" rel="noreferrer"
                            data-toggle="tooltip" data-placement="bottom" title="Telegram"
                            style="align-items: center; display: flex; height: auto; font-size: 11px;"><i
                                class="fi fi-brands-telegram"
                                style="color:black; margin-top: 3px; margin-right:4px;"></i><span
                                class="m-hide">Telegram</span></a></li>
                    <li><a href="https://wa.me/+917991037643" alt="Whatsapp" rel="noreferrer" data-toggle="tooltip"
                            data-placement="bottom" title="Whatsapp" target="black"
                            style="align-items: center; display: flex; height: auto; font-size: 11px;"><i
                                class="fi fi-brands-whatsapp"
                                style="color:black; margin-top: 3px; margin-right:4px;"></i><span
                                class="m-hide">Whatsapp</span></a></li>
                    <li><a href="#" alt="FAQ" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="FAQ"
                            style="align-items: center; display: flex; height: auto; font-size: 11px;"><i
                                class="fi fi-rr-interrogation"
                                style="color:black; margin-top: 3px; margin-right:4px;"></i><span
                                class="m-hide">FAQ</span></a>
                    </li>
                    <li><a href="#" alt="Android" rel="noreferrer" data-toggle="tooltip" data-placement="bottom"
                            title="Application" style="align-items: center; display: flex; height: auto; font-size: 11px;"><i
                                class="fi fi-brands-android"
                                style="color:black; margin-top: 3px; margin-right:4px;"></i><span
                                class="m-hide">Application</span></a></li>
                </ul>
            </div>
        </div>
    </div>
</div>
<style>/* Hide .sidetoggle-top on larger screens (PC) */
@media (min-width: 992px) {
  .sidetoggle-top {
    display: none;
  }
}
</style>
<div class="d-flex justify-content-between align-items-center" style="
    padding-left: 15px;
    padding-right: 15px; margin-top: 6px; width: 100%;">
  <!-- Left side: Menu + Logo -->
  <div class="d-flex align-items-center" style="flex: 0 0 50%; max-width: 50%;">
    <div (click)="onToggleSidenav()" class="sidetoggle-top" style="margin-top: 5px; margin-left: 5px;">
      <span class="material-symbols-outlined text-light">menu</span>
    </div>

    <a routerLink="/dashboard/cricket" class="navbar-brand text-white p-1 m-0 logo-bg" style="margin-left: 10px;">
      <img src="https://images.staticcontent.io/1xa/uimg/brand_logo.svg" width="135" height="60" style="max-width: 100% !important;" />
    </a>
  </div>

  <!-- Right side: Login + Signup -->
  <div class="d-flex align-items-center justify-content-end" style="flex: 0 0 50%; max-width: 50%;">
      
    <div class="loginbox" style="margin-right: 5px;"  *ngIf="!isLoggedIn">
      <button (click)="openlogin()" class="b2clogin" style="
        background-color: #f8bd23;
        background-image: linear-gradient(#f8bd23, #d48e2f);
        border: 1px solid #f8bd23;
        border-radius: 10px;
        color: #000 !important;
        font-family: 'Roboto Condensed', sans-serif;
        font-weight: 700;
        line-height: 26px;
        text-align: center;
        text-transform: uppercase;">Login</button>
    </div>

    <div class="joinbox"  *ngIf="!isLoggedIn">
      <button (click)="openRegister()" class="b2csignup" style="
        background-color: #f8bd23;
        background-image: linear-gradient(#f8bd23, #d48e2f);
        border: 1px solid #f8bd23;
        border-radius: 10px;
        color: #000 !important;
        font-family: 'Roboto Condensed', sans-serif;
        font-weight: 700;
        line-height: 26px;
        text-align: center;
        text-transform: uppercase;">Sign Up</button>
    </div>
  <div *ngIf="isLoggedIn" style="display:flex;    align-items: center;">
       <button routerLink="/dashboard/deposit" class="b2csignup" style="
        background-color: #f8bd23;
        background-image: linear-gradient(#f8bd23, #d48e2f);
        border: 1px solid #f8bd23;
        border-radius: 10px;
        color: #000 !important;
        font-family: 'Roboto Condensed', sans-serif;
        font-weight: 700;
        line-height: 26px;
        text-align: center;
        height:40px;
        text-transform: uppercase;">Deposit</button>
  <div class="p-1 mr-1" >
      
    <!-- <div (click)="openbetlist()" style="font-size: 10px; margin-top: 4px"> -->
    <div (click)="openbetlist()" class="bal-point">
      pts:
      <span class="bal-point" id="balance" *ngIf="exposure.length > 0">{{
        balance | number : ".2-2"
        }}</span>
      |
      <span class="bal-point" id="exposure" *ngIf="exposure.length > 0">{{
        exposure[0].exp_amount | number : ".2-2"
        }}</span>
    </div>
    <br />
    <div style="align-items: center; float: right; margin-top: -10px" mat-icon-button [matMenuTriggerFor]="menu"
      class="dropmenu d-inline-flex justify-content-center align-content-between">
      <span class="username-text" style="display: flex; width: 100%; font-size: 12px; white-space: nowrap">
        <!-- <span class="user-icon"><i class="fas fa-user"></i></span> -->
        <img src="../../assets/icons/user.png" alt="" style="width: 20px; filter: invert();">
        <!-- <span
          style="font-size: 18px"
          class="username-text material-symbols-outlined"
        >
          person
        </span> -->
        <span class="username">{{ username }}</span>
      </span>
      <img src="https://wver.sprintstaticdata.com/v79/static/front/img/arrow-down.svg" />
      <!-- <span class="material-symbols-outlined text-light" style="line-height: 0">
        arrow_drop_down
      </span> -->
    </div>

    <mat-menu #menu="matMenu">
      <button mat-menu-item id="menu-username"><span style="font-size: 14px; color: #ffffff; width: 100%;">Hi,
          {{username | uppercase}}</span></button>
      <button mat-menu-item routerLink="/dashboard/home"><span class="material-symbols-outlined">home</span>Home
      </button>
      <button mat-menu-item routerLink="/dashboard/deposit" *ngIf="username != 'demo' && user_id != '91'"
        style="color:#000000;"><img class="menu-icons" src="assets/icons/deposit-icon.png" />Deposit
      </button>
      <button mat-menu-item routerLink="/dashboard/withdraw" *ngIf="username != 'demo' && user_id != '91'"
        style=" color:#000000;">
        <img class="menu-icons" src="assets/icons/withdrawal-icon.png" />Withdraw
      </button>
      <!-- <button mat-menu-item routerLink="/dashboard/my-bets"><span class="material-symbols-outlined">mystery</span>My bets</button> -->
      <button mat-menu-item routerLink="/dashboard/profit-loss"><span
          class="material-symbols-outlined">signal_cellular_alt</span>Profit
        & loss
      </button>
      <button mat-menu-item routerLink="/dashboard/unsettled-bets"><span
          class="material-symbols-outlined">signal_cellular_alt</span>Unsettled
        bets
      </button>
      <!-- <button mat-menu-item routerLink="/dashboard/profile"><span class="material-symbols-outlined">person</span>My profile</button> -->
      <button mat-menu-item routerLink="/dashboard/ledger"><span
          class="material-symbols-outlined">monitoring</span>Account Statement
      </button>
      <button *ngIf="username != 'demo' && user_id != '91'" mat-menu-item routerLink="/dashboard/bonus"><span
          class="material-symbols-outlined">monitoring</span>Bonus
      </button>
      <button mat-menu-item routerLink="/dashboard/bonus-ledger" *ngIf="username != 'demo' && user_id != '91'"><span
          class="material-symbols-outlined">monitoring</span>Bonus
        Account Statement
      </button>
      <button mat-menu-item (click)="openDialog()" *ngIf="username != 'demo' && user_id != '91'"><span
          class="material-symbols-outlined">settings</span>Change
        password
      </button>
      <button mat-menu-item routerLink="/dashboard/terms"><span class="material-symbols-outlined">gavel</span>Terms
        & Conditions
      </button>
      <button mat-menu-item (click)="logout()"><span class="material-symbols-outlined">logout</span>Logout
      </button>

    </mat-menu>
  </div>
  </div>
  </div>
</div>
  <div class="d-flex flex-column p-2" *ngIf="!isLoggedIn && 3 > 6">
    <div class="d-flex justify-content-center justify-content-lg-end m-lg-1">
      <form class="form-inline flex-lg-row flex-column" [formGroup]="loginForm">
        <span *ngIf="errorMsg" class="text-white">
          {{ errorMsg }}
        </span>
        <input type="text" class="form-control" placeholder="Username" id="email" formControlName="username" />
        <span class="text-white" *ngIf="
            (loginFormControl.username.touched || submitted) &&
            loginFormControl.username.errors?.required
          ">
          Username is required
        </span>
        <input type="password" formControlName="password" class="form-control mt-1 mt-lg-0" placeholder="Password"
          id="pwd" />
        <span class="text-white" *ngIf="
            (loginFormControl.password.touched || submitted) &&
            loginFormControl.password.errors?.required
          ">
          Password is required
        </span>
        <div class="divider d-lg-block d-none"></div>
      </form>
      <div class="">
        <button class="d-lg-inline-block d-block btn-login" (click)="login()" *ngIf="!isLoggedIn">
          Login
        </button>
        <!--        <button class="d-lg-inline-block d-block btn-join text-uppercase  mt-1 mt-lg-0" (click)="openRegister()" *ngIf="!isLoggedIn">-->
        <!--          Register-->
        <!--        </button>-->
      </div>
    </div>
  </div>
  <!-- Navbar content -->
  <!-- <div style="position: absolute;">
    <button (click)="refresh()" style="margin: 10px; width: 33px; height: 26px; border: 1px solid #fff; background: #4c0670;" class="btn btn-sm p-0">
      <span class="material-symbols-outlined">
      cached
      </span>
    </button>
  </div> -->
  <!-- <span style="font-size: 18px; margin-left: 7px;" class="material-symbols-outlined text-warning font-weight-bold">cached</span> -->
  <!-- <div class="p-1" style="display: flex;" *ngIf="isLoggedIn && 3>6">
    <div class="p-2" (click)="refresh()">
      <div class="bn"><span class="bn-text">BAL</span></div>
      <div class="text-light text-center" *ngIf="exposure.length>0">{{balance+exposure[0].exp_amount| number : '.2-2'}}</div>
    </div>
    <div class="p-2" (click)="refresh()">
      <div class="bn"><span class="bn-text">EXP</span></div>
      <div class="text-light text-center" *ngIf="exposure.length>0">{{exposure[0].exp_amount| number : '.2-2'}}</div>
    </div>
    <div class="d-flex flex-column">
      <a style="align-items: center;" mat-icon-button [matMenuTriggerFor]="menu" class=" d-inline-flex justify-content-center align-content-between">
        <span style="width: 30px; font-size: 10px;">{{username}}</span>
        <span class="material-symbols-outlined text-light" style="font-size: 2em !important">
          arrow_drop_down
        </span>
      </a>

      <mat-menu #menu="matMenu">
        <button mat-menu-item id="menu-username"><span style="font-size: 14px; color: #fff; width: 100%;">Hi, {{username | uppercase}}</span></button>
        <button mat-menu-item routerLink="/dashboard/home"><span class="material-symbols-outlined">home</span>Home</button>
        <button mat-menu-item routerLink="/dashboard/deposit" style="background: darkgreen; color:#fff;"><img class="menu-icons" src="assets/icons/deposit-icon.png" />Deposit</button>
        <button mat-menu-item routerLink="/dashboard/withdraw" style="background: darkred; color:#fff;"><img class="menu-icons" src="assets/icons/withdrawal-icon.png" />Withdraw</button>
        <button mat-menu-item routerLink="/dashboard/my-bets"><span class="material-symbols-outlined">mystery</span>My bets</button>
        <button mat-menu-item routerLink="/dashboard/profit-loss"><span class="material-symbols-outlined">signal_cellular_alt</span>Profit & loss</button>
        <button mat-menu-item routerLink="/dashboard/unsettled-bets"><span class="material-symbols-outlined">signal_cellular_alt</span>Unsettled bets</button>
        //<button mat-menu-item routerLink="/dashboard/profile"><span class="material-symbols-outlined">person</span>My profile</button>
        <button mat-menu-item routerLink="/dashboard/ledger"><span class="material-symbols-outlined">monitoring</span>Account Statement</button>
        <button mat-menu-item (click)="openDialog()"><span class="material-symbols-outlined" >settings</span>Change password</button>
        <button mat-menu-item routerLink="/dashboard/terms-conditions"><span class="material-symbols-outlined" >gavel</span>Terms & Conditions</button>
        <button mat-menu-item (click)="logout()"><span class="material-symbols-outlined">logout</span>Logout</button>
      </mat-menu>
    </div>
  </div> -->


<div [class.mt-2px]="!isLoggedIn" style="overflow-x: auto; white-space: nowrap; width:100%;background: #eaeaea;"
  class="main-menu" style="     overflow-x: auto;
background: #f8bd23; box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
    height: 100%;
    height: 40px;
    left: 0;
    top: 0;
    width: 100%;
    justify-content: start !important;
">
    <style>
        .sub-menu-item.new-height {
  display: inline-block;     /* Shrinks to fit content */
  white-space: nowrap;       /* Prevents wrapping */
  overflow: hidden;          /* Prevents scrollbars */
  text-overflow: clip;       /* Ensures no extra "..." or clipping */
  padding: 0;  
  height: auto;
  
      /* height: 44px;/* Optional: remove if not needed */
}
.menu-text2 {
  display: inline;            /* Ensures content flows inline */
}

.menu-text2 p {
  margin: 0;                  /* Ensures no extra spacing */
  white-space: nowrap;       /* Again, prevent wrapping */
}

    </style>
  <div class="sub-menu-item new-height" routerLinkActive="active" routerLink="/dashboard/livecasino">
    <span class="menu-text2">
      <p class="m-0">Int Casino </p>
    </span>
  </div>
  <div class="sub-menu-item new-height" routerLinkActive="active" routerLink="/dashboard/home">
    <span class="menu-text2">
      <p class="m-0">In-play </p>
    </span>
  </div>
  <div class="sub-menu-item new-height" routerLinkActive="active" routerLink="/dashboard/cricket">
    <span class="menu-text2">
      <p class="m-0">Cricket </p>
    </span>
  </div>
  <div class="sub-menu-item new-height" routerLinkActive="active" routerLink="/dashboard/football">
    <span class="menu-text2">
      <p class="m-0">Football </p>
    </span>
  </div>
  <div class="sub-menu-item new-height" routerLinkActive="active" routerLink="/dashboard/tennis">
    <span class="menu-text2">
      <p class="m-0">Tennis <span class="ml-3">&nbsp;</span></p>
    </span>
  </div>
 <div *ngFor="let vendor of vendors" class="sub-menu-item new-height">
  <span class="menu-text2">
    <a 
      [href]="'/dashboard/livecasino?vendorId=' + vendor.providerCode"
      class="menu-link"
    >
      <p class="m-0" style="color:#000;     font-weight: bold;">{{ vendor.providerName }} <span class="ml-3">&nbsp;</span></p>
    </a>
  </span>
</div>


</div>



</nav>
<marquee behavior="" direction="" 
  style="color: #ffffff; display: none; background: linear-gradient(90.86deg, #2D7BB6 0%, #01073A 50%, #0C4EB1 100%);;">
  {{notification}}</marquee>
<div *ngIf="isLoggedIn && 3 > 6" style="padding: 3px" class="sub-nav d-flex align-items-center justify-content-center">
  <div class="sub-old sub-menu-item" style="background: #1dc31d; border-radius: 10px; width: 100%"
    routerLink="/dashboard/deposit">
    <img class="tab-icon" src="assets/icons/deposit-icon.png" />DEPOSIT
  </div>
  <div class="sub-old sub-menu-item" style="background: #e53c3c; border-radius: 10px; width: 100%"
    routerLink="/dashboard/withdraw">
    <img class="tab-icon" src="assets/icons/withdrawal-icon.png" />WITHDRAW
  </div>
</div>
<!-- <div *ngIf="isLoggedIn" (click)="onToggleSidenav()" class="sidebar-toggle">
  <span class="material-symbols-outlined">
    menu
  </span>
</div> -->
<div *ngIf="3 > 6" style="
    overflow-x: auto;
    white-space: nowrap;
    background-color: #000 !important;
    width: 100%;
  " class="main-menu sub-nav">
  <div class="sub-menu-item new-height" routerLinkActive="active" routerLink="/dashboard/home">
    <img class="menu-icon" src="assets/icons/menu-home.png" />
    <span class="menu-text">Home</span>
  </div>
  <!-- <div class="sub-menu-item new-height" routerLinkActive="active" routerLink="/dashboard/inplay-match">
    <img class="menu-icon" src="assets/icons/menu-inplay.png" />
    <span class="menu-text">In-play</span>
  </div> -->
  <!-- <div class="sub-menu-item" (click)="sports()" routerLinkActive="active" routerLink="/dashboard/match">SPORTS</div> -->
  <div class="sub-menu-item new-height" routerLinkActive="active" routerLink="/dashboard/cricket">
    <img class="menu-icon" src="assets/icons/menu-cricket.png" />
    <span class="menu-text">Cricket</span>
  </div>
  <!-- <div class="sub-menu-item new-height" routerLinkActive="active" routerLink="/dashboard/football" disabled="true">
    <img class="menu-icon" src="assets/icons/menu-football.png" />
    <span class="menu-text">Football</span>
  </div> -->
  <!-- <div class="sub-menu-item new-height" routerLinkActive="active" routerLink="/dashboard/tennis" disabled="true">
    <img class="menu-icon" src="assets/icons/menu-tennis.png" />
    <span class="menu-text">Tennis</span>
  </div> -->
  <!-- <div class="sub-menu-item new-height" routerLinkActive="active" routerLink="/dashboard/livecasino">
    <img class="menu-icon" src="assets/icons/menu-casino.png" />
    <span class="menu-text">Int Casino</span>
  </div> -->
</div>
<div *ngIf="news && news.trim() !== ''" class="sub-nav d-flex align-items-center mrqstyle" style="height: 30px">
  <div class="marquee" style="display: none;">
    <marquee>
      {{ news }}
    </marquee>
  </div>
  <div class="marquee-head">
    <img src="assets/icons/speaker.svg" alt="news" style="display: none; height: 20px; margin-left: 10px" class="ng-tns-c81-1" />
  </div>
</div>
